/** Plain scripted-narrative paragraph — distinct from `assistant-text`, which is LLM-generated. */
export function NarrativeMessage({ text }: { text: string }) {
  return <p className="text-muted-foreground text-xs leading-5">{text}</p>;
}
